import { init as monterosaInit } from './init'
import {
  getFormStorageIdentity,
  getStorageKeys,
  readJson,
} from '../../utils/votingStorage.js'

/**
 * Wrapper around Monterosa's init function that adds SSO authentication logic
 * This preserves the original Monterosa init function while adding our custom SSO handling
 */
export async function initWithSSO(
  host,
  projectId,
  onEventUpdate,
  ssoAuthState = null,
  options = {}
) {
  const monterosaResult = await monterosaInit(
    host,
    projectId,
    onEventUpdate,
    options
  )
  const hasSSOAuth = ssoAuthState?.isAuthenticated && ssoAuthState?.user
  const activeEventId = monterosaResult.activeEvent?.id
  const activeFormId =
    monterosaResult.activeEvent?.fields?.formId?.data?.[0]?.id

  const hasExistingSubmission = Boolean(
    activeEventId &&
      activeFormId &&
      getStorageKeys().some((key) => {
        const identity = getFormStorageIdentity(key)

        return (
          identity?.eventId === activeEventId &&
          String(identity.currentFormId) === String(activeFormId) &&
          Boolean(readJson(key)?.lastVoteDate)
        )
      })
  )

  return {
    ...monterosaResult,
    ssoAuth: {
      isAuthenticated: hasSSOAuth,
      hasExistingSubmission,
      user: ssoAuthState?.user || null,
      shouldShowLogin: !hasSSOAuth,
    },
  }
}
